import type { TrainingEvalRunFilters } from "@/api/trainingEval";
import type { SelectedPolicyRef, TrainingEvalRunScope } from "@/modules/training/public";
import type { EvalRunRowClickHandler } from "./EvalRunTableRow";
import { EvalRunTableSource } from "./EvalRunTableSource";

export const DEFAULT_EVAL_RUN_PAGE_SIZE = 20;

/** Evaluation Results 창이 수명 전체에 걸쳐 보존할 table source를 만든다. */
export function createEvalRunTableSource({
  scope,
  pageSize,
  baseFilters,
  policies,
  rowClickHandler,
}: {
  scope: TrainingEvalRunScope;
  pageSize: number;
  baseFilters: Pick<TrainingEvalRunFilters, "memberUuid" | "experimentId">;
  policies: readonly SelectedPolicyRef[];
  rowClickHandler: EvalRunRowClickHandler;
}): EvalRunTableSource {
  return new EvalRunTableSource({
    scope,
    pageSize,
    initialFilters: { ...baseFilters },
    rowClickHandler,
    resolveErrorMessage: resolveEvalRunsError,
    initialPolicyFilter: policies,
  });
}

function resolveEvalRunsError(error: unknown): string {
  if (error instanceof Error) return error.message;
  return "Evaluation 결과를 불러오지 못했습니다. 다시 시도해 주세요.";
}
